import "./styles.scss"

import React, { useState } from "react"
import { useTranslation } from "react-i18next"

import { setCustomCookie } from "../../utils/cookies"

const AccessControl = () => {
  const { t } = useTranslation("account")
  const [password, setPassword] = useState("")

  const onSubmit = event => {
    const isWindowDefined = typeof window !== "undefined"
    event.preventDefault()
    setCustomCookie("ttf-access", password, 2)
    isWindowDefined && window.location.reload()
  }
  return (
    <div className="access-container">
      <h1>{t("access.heading")}</h1>
      <form onSubmit={onSubmit}>
        <input
          name="password"
          type="password"
          aria-label={t("access.password")}
          value={password}
          onChange={event => setPassword(event.target.value)}
        />
        <button type="submit">{t("access.enter")}</button>
      </form>
    </div>
  )
}

export default AccessControl
